var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tour-gallery-thumb-wrapper"},[_c('img',{staticClass:"thumb-image lazyload",class:{selected: _vm.selected},attrs:{"width":"200","height":"200","alt":_vm.image.description,"data-src":_vm.getContentfulImgURL({
      url: _vm.image.url,
      width: 260,
      height: 180,
      quality: 90
    })}})])}
var staticRenderFns = []

export { render, staticRenderFns }